import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../../helpers/saga';
import { fetchItemsAndPackagesSkus as fetchItemsAndPackagesSkusRoutine } from './routines';

export const fetchItemsAndPackagesSkus = ({ payload: body }) =>
  sagaRoutineRequest(fetchItemsAndPackagesSkusRoutine, {
    request: () => call(Api.fetchItemsAndPackagesSkus, body)
  });
